import ClientModule from "@gqlapp/module-client-react";
import ViewRoute from "@modules/video/containers/view";
import ListRoute from "@modules/video/containers/list";
export default new ClientModule(ViewRoute, ListRoute);
